import { ResultItem } from "../../hooks/useFullTextSearch";
import { KeyboardShortcutState } from "../../redux/types";

export type TItem = {
    id: string;
    name: string; 
    isDesactivatable: boolean;
    isOverridable: boolean;
    hasConflict: boolean;
}

export type TUpdateShortcutView = { 
    parentId?: string,
    item: KeyboardShortcutState, 
    setSavedNotification: (value: string) => void, 
    setResetShortcut: (value: TResetShortcut) => void, 
    setFeedbackType: (value: string | null) => void 
}

export type TResetShortcut = { isReset: boolean, shortcutName: string }

export enum TView { 
    UPDATE="update", 
    READ="read"
};

export type TGroupedItem = Record<string, ResultItem<KeyboardShortcutState>[]>;

export type TShortcutListDrawer = {
    id?: string,
    title?: string,
    defaultGroupTitle?: string,
    isOpen: boolean,
    onCloseShorcuts: () => void,
    viewMode?: "read" | "update",
    showBackdrop: boolean,
    zIndex?: number,
    offset?: string,
    enableShortcutsActions?: boolean,
    enableSearch?: boolean,
}